import { useEffect, useState } from "react";

const useDropdownWithKeys = (
  items,
  { onEnter, onEscape, onArrowDown, onArrowUp } = {},
) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);

  useEffect(() => setCurrentIndex(-1), [isOpen]);
  useEffect(() => {
    if (!items || items.length === 0) {
      setIsOpen(false);
      return;
    }
    if (items && items.length > 0) {
      setIsOpen(true);
    }
  }, [items]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (onEnter) {
        onEnter();
      }
    }
    if (
      event.key === "ArrowDown" &&
      items.length > 0 &&
      currentIndex < items.length
    ) {
      event.preventDefault();
      if (!isOpen) {
        setIsOpen(true);
        return;
      }
      setCurrentIndex(currentIndex + 1);

      if (onArrowDown) {
        onArrowDown();
      }
    }

    if (event.key === "ArrowUp" && items.length > 0 && currentIndex > -1) {
      event.preventDefault();
      setCurrentIndex(currentIndex - 1);

      if (onArrowUp) {
        onArrowUp();
      }
    }
    if (event.key === "Escape") {
      event.preventDefault();
      if (isOpen) {
        setIsOpen(false);
      }

      if (onEscape) {
        onEscape();
      }
    }
  };

  return [
    { onKeyDown: handleKeyDown },
    isOpen,
    currentIndex,
    { open: () => setIsOpen(true), close: () => setIsOpen(false) },
  ];
};

export default useDropdownWithKeys;
